import { Box, Stack } from "@mui/material";
import React from "react";
import styled, { useTheme } from "styled-components";
import AppBar from "./AppBar";
interface MainProps {
  children: React.ReactNode;
  hidePages?: boolean;
  sx?: any;
}

const StyledMinimalContainer = styled(Box)(({ theme }) => ({
  padding: 0,
  width: "100%",
}));

const Minimal: React.FC<MainProps> = ({ children, sx }) => {
  const theme = useTheme();

  return (
    <StyledMinimalContainer sx={{ height: "100vh", ...sx }}>
      <AppBar fixedTopBar={true} />
      <Stack
        justifyContent="center"
        alignItems="center"
        padding={4}
        height="100%"
      >
        {children}
      </Stack>
    </StyledMinimalContainer>
  );
};

export default Minimal;
